import { defineFeature } from "../../app/feature";
import { CorpusRunsPage } from "./CorpusRunsPage";
import { RunDashboardPage } from "./RunDashboardPage";
import { RunJobPage } from "./RunJobPage";

/** Corpus Runs: run progress, metrics, and diagnostics (task 4030.8). Owned by the workflow
 * lane. Every page is read-only; controls are authorized by the run API. */
export default defineFeature({
  id: "corpus-runs",
  title: "Corpus Runs",
  routes: [
    { path: "/corpus-runs", Component: CorpusRunsPage },
    { path: "/corpus-runs/:runId", Component: RunDashboardPage },
    { path: "/corpus-runs/:runId/jobs/:jobId", Component: RunJobPage },
  ],
  nav: { label: "Corpus Runs", path: "/corpus-runs", section: "Corpus Runs", order: 10 },
  permissions: ["engagement.read", "engagement.manage"],
});
